<template>
  <div class="breed-component">
    <div
      class="fl-sym-mt-6 fl-sym-p-2 fl-sym-border fl-sym-border-graduate fl-sym-rounded-sm"
      @click="$refs['breed'].focus()"
    >
      <div class="fl-sym-text-secondary fl-sym-text-xxs">Breed</div>
      <input
        ref="breed"
        class="focus:fl-sym-outline-none fl-sym-w-full"
        v-model="value.breed"
        required
      />
    </div>

    <switch-box class="fl-sym-mt-5" v-model="value.gender" :options="options" />

    <div class="fl-sym-flex fl-sym-justify-between fl-sym-mt-5">
      <div class="fl-sym-text-lg fl-sym-text-intermediate">Neutered</div>
      <switch-check v-model="value.neutered" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import switchBox from "@/components/form/checkbox/switch-gender.vue"
import switchCheck from "@/components/form/switch/switch.vue"
export default {
  components: {
    switchBox,
    switchCheck,
  },
  computed: {
    ...mapState({
      pet: (state) => state.pet.pet,
    }),
  },
  props: {
    value: {
      default:() => ({
        breed: null,
        gender: "male",
        neutered: false,
      }),
    },
    type: Object
  },
  data() {
    return {
      options: [
        {
          name: "Male",
          value: "male",
        },
        {
          name: "Female",
          value: "female",
        },
      ],
    }
  },
}
</script>

<style scoped></style>
